import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
import { Facebook } from 'lucide-react';
import TrustPilotWidget from '@/components/common/TrustPilotWidget';

const NewsletterSubscription = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast({
        title: "Email required",
        description: "Please enter your email address",
        variant: "destructive",
      });
      return;
    }

    setIsLoading(true);
    
    try {
      const { data, error } = await supabase.functions.invoke('newsletter-subscribe', {
        body: { email }
      });

      if (error) throw error;

      toast({
        title: "Successfully subscribed!",
        description: "Thank you for subscribing to our newsletter.",
      });
      
      setEmail('');
    } catch (error: any) {
      console.error('Subscription error:', error);
      toast({
        title: "Subscription failed",
        description: error.message || "Failed to subscribe. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h3 className="text-xl font-semibold mb-4" style={{ color: '#D4AF37', textShadow: '0 3px 6px rgba(0, 0, 0, 0.6), 0 0 15px rgba(212, 175, 55, 0.4)', fontSize: '1.3em' }}>Stay Updated</h3>
      <p className="mb-4 text-gray-300">
        Subscribe to our newsletter for latest products, offers and farming tips.
      </p>
      <form onSubmit={handleSubmit} className="mb-4">
        <div className="flex">
          <Input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="rounded-l-md rounded-r-none flex-1 text-springbok-800 focus:outline-none"
            disabled={isLoading}
          />
          <Button
            type="submit"
            className="px-4 py-2 rounded-r-md rounded-l-none font-medium"
            disabled={isLoading}
            data-gradient="gold"
          >
            {isLoading ? 'Subscribing...' : 'Subscribe'}
          </Button>
        </div>
      </form>
      <div className="flex items-center space-x-4 mt-6">
        <a href="https://www.facebook.com/Kooperasiewinkel" target="_blank" rel="noopener noreferrer" className="bg-gradient-green p-2 rounded-full transition-all hover:brightness-110 hover:scale-105">
          <Facebook size={20} />
        </a>
        <div className="ml-2" style={{ minHeight: '52px' }}>
          <TrustPilotWidget />
        </div>
      </div>
    </div>
  );
};

export default NewsletterSubscription;